/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Phase from '../phase-core/Phase';

const { min, max, pow, PI } = Math;

export default class Spin extends Phase {

	static shimmer_frequency = new Float32Array([1, 2, 3, 5, 0, 0, 0, 0]);
	static shimmer_magnitude = new Float32Array([7, 4, 2, 1, 0, 0, 0, 0]);
	static shimmer_phase = new Float32Array([0, 0.7, 0.21, 0.39, 0, 0, 0, 0]);
	static shimmer_color = new Float32Array([2, 1, 0, 1]);
	static star_color = new Float32Array([3, 1, 0, 1]);

	getPreludeLength() {
		return 0.5;
	}

	getPostludeLength() {
		return 0.5;
	}

	run({ time, pulse, frame_opts }) {
		const half_length = this.length / 2;
		frame_opts.star = pow(pulse, 10);
		if (time.relative >= 0 && time.relative <= this.length) {
			frame_opts.rotation += min(half_length, time.relative) * 0.5;
			frame_opts.rotation -= max(0, time.relative - half_length) * 0.25;
		}
		if (time.relative >= half_length) {
			frame_opts.size *= 2 + 1 * pow(pulse, 16);
		} else {
			frame_opts.size *= 1 + 3 * pow(pulse, 20);
		}
		if (time.beat > 1) {
			frame_opts.shimmer.frequency = Spin.shimmer_frequency;
			frame_opts.shimmer.magnitude = Spin.shimmer_magnitude;
			frame_opts.shimmer.phase = Spin.shimmer_phase;
			for (let i = 0; i < 4; i++) {
				frame_opts.shimmer.phase[i] += 5 * time.relative * (i * i + 1);
				frame_opts.shimmer.phase[i] %= PI * 2;
			}
			frame_opts.shimmer.scale = 0.006;
			frame_opts.shimmer.shift = 0;
			frame_opts.shimmer.skew = -3 * pulse;
		}

		frame_opts.shimmer_color = Spin.shimmer_color;
		frame_opts.star_color = Spin.star_color;
	}

}
